export const SYSTEM_FONT_DEFAULT = "Segoe UI";

export const SYSTEM_FONT_OPTIONS = [
  { value: "Segoe UI", label: "Segoe UI (padrão do sistema)", family: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' },
  { value: "Inter", label: "Inter", family: 'Inter, "Segoe UI", Arial, sans-serif', googleFamily: "Inter:wght@300;400;500;600;700;800" },
  { value: "Roboto", label: "Roboto", family: 'Roboto, "Segoe UI", Arial, sans-serif', googleFamily: "Roboto:wght@300;400;500;700" },
  { value: "Poppins", label: "Poppins", family: 'Poppins, "Segoe UI", Arial, sans-serif', googleFamily: "Poppins:wght@300;400;500;600;700" },
  { value: "Nunito Sans", label: "Nunito Sans", family: '"Nunito Sans", "Segoe UI", Arial, sans-serif', googleFamily: "Nunito+Sans:wght@300;400;500;600;700;800" },
  { value: "Open Sans", label: "Open Sans", family: '"Open Sans", "Segoe UI", Arial, sans-serif', googleFamily: "Open+Sans:wght@300;400;500;600;700;800" },
  { value: "Montserrat", label: "Montserrat", family: 'Montserrat, "Segoe UI", Arial, sans-serif', googleFamily: "Montserrat:wght@300;400;500;600;700;800" },
];

export const getSystemFontOption = (value) =>
  SYSTEM_FONT_OPTIONS.find((font) => font.value === value) || SYSTEM_FONT_OPTIONS[0];

export const getSystemFontFamily = (value) => getSystemFontOption(value).family;

export const getSystemFontOverride = (value) =>
  SYSTEM_FONT_OPTIONS.some((font) => font.value === value) ? value : "";

export const loadSystemFonts = (values = []) => {
  const googleFamilies = [...new Set(
    values.map((value) => getSystemFontOption(value).googleFamily).filter(Boolean)
  )];
  const linkId = "configured-system-font";
  const currentLink = document.getElementById(linkId);

  if (!googleFamilies.length) {
    currentLink?.remove();
    return;
  }

  const href = `https://fonts.googleapis.com/css2?${googleFamilies.map((family) => `family=${family}`).join("&")}&display=swap`;
  if (currentLink?.getAttribute("href") === href) return;

  const link = currentLink || document.createElement("link");
  link.id = linkId;
  link.rel = "stylesheet";
  link.href = href;
  if (!currentLink) document.head.appendChild(link);
};
